import { X } from "lucide-react";

export default function ContingenciaDetailModal({ evento, onClose }) {
  const detalle = Array.isArray(evento.detalle_dte) ? evento.detalle_dte : [];

  return (
    <>
      <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content card" style={{ maxHeight: "90vh" }}>
            <div className="card-header">
              <h3 className="card-title" style={{ margin: 0 }}>⚠️ Detalle del Evento de Contingencia</h3>
              <button className="btn btn-secondary btn-sm" onClick={onClose}>
                <X size={18} />
              </button>
            </div>

            <div className="card-body" style={{ overflowY: "auto" }}>
              <div style={{ padding: "16px", background: "#f7fafc", borderRadius: "10px", border: "2px solid #e2e8f0", marginBottom: "16px" }}>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Código de Generación</label>
                  <div style={{ fontSize: "12px", fontWeight: 600, color: "#7c3aed", wordBreak: "break-all" }}>{evento.codigo_generacion}</div>
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Período de Contingencia</label>
                  <div style={{ fontSize: "14px" }}>{evento.f_inicio} {evento.h_inicio} — {evento.f_fin} {evento.h_fin}</div>
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Motivo</label>
                  <div style={{ fontSize: "14px" }}>{evento.motivo_contingencia || "N/A"}</div>
                </div>
                <div>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Estado</label>
                  <span style={{ padding: "4px 12px", background: evento.estado === "VALIDADO" ? "#d1fae5" : "#fee2e2", color: evento.estado === "VALIDADO" ? "#065f46" : "#991b1b", borderRadius: "6px", fontSize: "12px", fontWeight: 600 }}>
                    {evento.estado}
                  </span>
                </div>
              </div>

              <h4 style={{ fontSize: "16px", marginBottom: "12px" }}>📋 Documentos Incluidos ({detalle.length})</h4>
              <div className="table-container">
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Tipo</th>
                      <th>Código de Generación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalle.map((d, i) => (
                      <tr key={i}>
                        <td>{d.noItem}</td>
                        <td>{d.tipoDoc}</td>
                        <td style={{ fontFamily: "monospace", fontSize: "11px" }}>{d.codigoGeneracion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-body" style={{ borderTop: "2px solid #e2e8f0", display: "flex", justifyContent: "flex-end", paddingTop: "var(--spacing-md)" }}>
              <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}